{
  "welcome": "Bienvenue chez",
  "instructions": "Appuyez ci-dessous pour commencer votre processus d'enregistrement.",
  "startCheckIn": "Commencer l'enregistrement",
  "missingWarehouseTitle": "Entrepôt manquant",
  "missingWarehouseMessage": "Le lien est invalide, il doit contenir l'ID de l'entrepôt",
  "recaptchaAttribution": "Ce site est protégé par reCAPTCHA et les {privacyPolicy} et {termsOfService} de Google s'appliquent.",
  "recaptchaPrivacyPolicy": "Règles de confidentialité",
  "recaptchaTermsOfService": "Conditions d'utilisation",
  "lookupTitle": "Ajoutez le numéro de référence ou de confirmation pour trouver votre rendez-vous",
  "referenceNumberLabel": "Numéro de référence ou numéro de confirmation",
  "referenceNotFoundError": "Le numéro de référence ou de confirmation ne correspond à aucun rendez-vous valide.",
  "checkIn": "S'enregistrer",
  "loadTypeLabel": "Type de chargement",
  "directionLabel": "Direction",
  "operationLabel": "Opération",
  "dockLabel": "Quai",
  "orDivider": "ou",
  "noReferenceTitle": "Je n'ai pas de numéro de confirmation",
  "noReferenceDescription": "Continuez sans rendez-vous en utilisant le processus d'enregistrement standard.",
  "checkInWithoutAppointment": "S'enregistrer sans rendez-vous",
  "readyToCheckInTitle": "Prêt à vous enregistrer ?",
  "readyToCheckInDescription": "Appuyez ci-dessous pour commencer. Vous saisirez vos informations à l'écran suivant.",
  "referenceRequiredHint": "Un numéro de référence est requis pour s'enregistrer à cet emplacement.",
  "haveAppointment": "J'ai un rendez-vous",
  "direction": {
    "inbound": "Entrant",
    "outbound": "Sortant",
    "inOut": "Entrant et sortant",
    "load": "Chargement",
    "unload": "Déchargement"
  },
  "operation": {
    "live": "En direct",
    "drop": "Dépose",
    "other": "Autre"
  }
}
